import { api } from '~/lib/api.js'

export const getAanmeldingen = ({ dag_id, normalizeAsVliegers }) => async (dispatch) => {
  dispatch({
    type: 'AANMELDING_PENDING'
  })
  const data = await api.get(`aanmeldingen/${dag_id}/get_day.json`)
  data && dispatch({
    type: 'AANMELDING_SUCCESS',
    normalizeAsVliegers,
    default_vliegers: data.default_vliegers,
    dag_id,
    ...data
  })
  return data
}

export const saveAanmelding = (payload) => async (dispatch) => {
  const data = await api.post('aanmeldingen/save.json', payload)
  data && dispatch({
    type: 'AANMELDING_SUCCESS',
    dag_id: payload.dag_id,
    ...data
  })
  data && dispatch({
    type: 'UPDATE_MIJN_AANMELDINGEN',
    dag_id: payload.dag_id,
    aanmelding: payload.action === 'meld_af' ? null : 1
  })

  payload.kist && dispatch({
    type: 'SET_PERSONAL_PREFERENCES',
    preferences: { kist_aanmelding: payload.kist }
  })
  return data
}

export const saveRegistration = (payload) => async (dispatch) => {
  const data = await api.post('aanmeldingen/registration.json', payload)
  data && dispatch({
    type: 'AANMELDING_SUCCESS',
    dag_id: payload.dag_id,
    ...data
  })
  return data
}

export const saveMessage = (payload) => async (dispatch) => {
  const data = await api.post('aanmeldingen/message.json', payload)
  data && dispatch({
    type: 'SAVE_AANMELD_MESSAGE',
    action: payload.action,
    message: data
  })
  return data
}
